/* eslint-disable no-unused-vars */
import { Transform } from '@warp-drive/legacy/serializer/transform';

export default class Json extends Transform {
  deserialize(serialized) {
    if (serialized == null || serialized === '') return null;
    if (typeof serialized !== 'string') return serialized;
    try {
      return JSON.parse(serialized);
    } catch (e) {
      return null;
    }
  }

  serialize(deserialized) {
    if (deserialized == null) return null;
    if (typeof deserialized === 'string') return deserialized;
    return JSON.stringify(deserialized);
  }
}
